import { Link } from '@monthio/design-system'
import { parseLinksFromText } from './TextWithLinks.Util'

/**
 * Component for turning links in a text into clickable, accessible links
 */
export const TextWithLinks = ({ rawText }: { rawText: string }) => {
	return (
		<>
			{parseLinksFromText(rawText).map((part, i) =>
				part.isLink ? (
					// eslint-disable-next-line react/no-array-index-key
					<Link href={part.segment} key={i}>
						{part.segment}
					</Link>
				) : (
					part.segment
				),
			)}
		</>
	)
}
